<template>
  <div>
    <div class="flex-row flex-spbt">
      <p class="component-title">{{ $t('TheNavbar.setComment') }}</p>
    </div>
    <ImprovedFeedbackCommentSetting />
  </div>
</template>

<script>
import ImprovedFeedbackCommentSetting from '../../components/Saai/SetComment/ImprovedFeedbackCommentSetting.vue';

export default {
  name: 'SetComment',
  components: {
    ImprovedFeedbackCommentSetting,
  },
  created() {
    const currentRoutePath = JSON.parse(localStorage.getItem('currentRoutePath'));
    if (currentRoutePath === '/saai/setComment' && currentRoutePath !== '/saai/createImprovedFeedback') {
      localStorage.removeItem('currentRoutePath');
      this.$router.push('/saai/createImprovedFeedback');
    }    
  }
};
</script>
